export default __webpack_public_path__ + "static/logo-911a5d3d860b3feffbed028611556aeb.svg";